import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { SalonMonsterLoadMaskModule } from '../../../../components/smr-load-mask/smr-load-mask.module';
import { StylistPickerModule } from 'src/app/components/stylist-picker/stylist-picker.module';
import { MaskitoModule } from '@maskito/angular';
import { SplitTipComponent } from './split-tip.component';
import { SharedModule } from '../../../../shared.module'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SalonMonsterLoadMaskModule,
    StylistPickerModule,
    MaskitoModule,
    SharedModule
  ],
  declarations: [SplitTipComponent]
})
export class SplitTipComponentModule {}
